import { useMutation } from '@tanstack/react-query';

export default function useDeleteProfit() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (id: number) => {
      const res = await fetch(`/agent/api/profits/${id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.errors?.join(', ') || '売上票の削除に失敗しました');
      }
    },
  });
}
